// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wallet-balance{align-items:center;background:var(--reloaved-gradient);border-radius:var(--spacing-tiny);display:flex;height:25px;padding:2px}.wallet-balance__inner{align-items:center;background:var(--color-lightest);border-radius:2px;display:flex;height:100%;padding:0 var(--spacing-smaller)}.wallet-balance__text{font-size:var(--font-size-smaller);font-weight:var(--font-weight-semibold);position:relative;top:1px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
